module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "TUESVolumeCardpdf",
    attrs: {
      "id": "TUESVolumeCardpdf"
    }
  }, [_c('section', {
    staticClass: "dashboard"
  }, [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showDash == true) ? _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard w-100 d-block",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px",
      "height": "auto !important"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "10"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v(_vm._s(_vm.$route.name))])], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-navbar-nav', {
    staticClass: "pull-right mr-auto"
  }, [_c('b-nav-form', [_c('b-button', {
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "variant": "outline-success",
      "disabled": _vm.monthContainerExportList.length <= 0
    },
    on: {
      "click": _vm.exportMonthTableToExcel
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "variant": "outline-info"
    },
    on: {
      "click": _vm.getPDF
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-download",
    attrs: {
      "aria-hidden": "true"
    }
  })])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('b-card', [_c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "opens": _vm.openLeft,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    on: {
      "update": _vm.getTotalVolumes
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeName,
      "option-value": "transportTypeVal",
      "option-text": "transportTypeText",
      "placeholder": "Select Export / Import"
    },
    model: {
      value: (_vm.Filter.transportTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "transportTypeFilter", $$v)
      },
      expression: "Filter.transportTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "id": "clientNamenew",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' ? true : false
    },
    on: {
      "input": _vm.getTotalVolumes
    },
    model: {
      value: (_vm.Filter.clientFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "clientFilter", $$v)
      },
      expression: "Filter.clientFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' ? true : false
    },
    on: {
      "input": _vm.getTotalVolumes
    },
    model: {
      value: (_vm.Filter.shippingIdFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "shippingIdFilter", $$v)
      },
      expression: "Filter.shippingIdFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchFilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All",
      "isDisabled": _vm.$sessionsStorage.get('cust_username') == 'pankajmishra' ? false : _vm.$sessionsStorage.get('designation') != 'Admin' ? true : false
    },
    on: {
      "input": _vm.getTotalVolumes
    },
    model: {
      value: (_vm.Filter.branchFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "branchFilter", $$v)
      },
      expression: "Filter.branchFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Container Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllContainerTypeList'],
      "option-value": "containerTypeId",
      "option-text": "containerType",
      "placeholder": "Select Container Type"
    },
    on: {
      "input": _vm.getTotalVolumes
    },
    model: {
      value: (_vm.Filter.containerTypeFilter),
      callback: function($$v) {
        _vm.$set(_vm.Filter, "containerTypeFilter", $$v)
      },
      expression: "Filter.containerTypeFilter"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "gutr mt-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("TOT. CONTAINERS TEUS EXP")]), _vm._v(" "), (_vm.mainExecutionDetails.totalTUESExec > 0) ? _c('div', {
    staticClass: "fluid-container card"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('table', {
    staticClass: "table mb-0"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Execution = " + _vm._s(_vm.mainExecutionDetails.totalExec))]), _vm._v(" "), _c('th', [_vm._v("CONTAINERS = " + _vm._s(_vm.mainExecutionDetails.totalContExec))]), _vm._v(" "), _c('th', [_vm._v("TEUS = " + _vm._s(_vm.mainExecutionDetails.totalTUESExec))])])])]), _vm._v(" "), _c('table', {
    staticClass: "table mb-0"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("\n                        Export Execution = " + _vm._s(_vm.mainExecutionDetails.totalExpExec) + "\n                      ")]), _vm._v(" "), _c('th', [_vm._v("\n                        Export CONTAINERS = " + _vm._s(_vm.mainExecutionDetails.totalExpContExec) + "\n                      ")]), _vm._v(" "), _c('th', [_vm._v("Export TEUS = " + _vm._s(_vm.mainExecutionDetails.totalExpTUESExec))])])])]), _vm._v(" "), _c('table', {
    staticClass: "table mb-0"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("\n                        Import Execution = " + _vm._s(_vm.mainExecutionDetails.totalImpExec) + "\n                      ")]), _vm._v(" "), _c('th', [_vm._v("\n                        Import CONTAINERS = " + _vm._s(_vm.mainExecutionDetails.totalImpContExec) + "\n                      ")]), _vm._v(" "), _c('th', [_vm._v("Import TEUS = " + _vm._s(_vm.mainExecutionDetails.totalImpTUESExec))])])])])])]) : _vm._e()]), _vm._v(" "), (
    _vm.monthContainerExportList.length > 0 &&
    _vm.Filter.transportTypeFilter == 'Export'
  ) ? _c('div', {
    staticClass: "col-md-12 mt-2 mb-2 card"
  }, [_c('div', {
    staticClass: "text-right p-2"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-success"
    },
    on: {
      "click": function($event) {
        _vm.exportMonthTableToExcel('Export')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-file-excel-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                Export\n              ")])], 1), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-sm card-body"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("SN")]), _vm._v(" "), _c('th', [_vm._v("Month")]), _vm._v(" "), _c('th', [_vm._v("Export Tot Exe")]), _vm._v(" "), _c('th', [_vm._v("Export Tot Containers")]), _vm._v(" "), _c('th', [_vm._v("Export Tot TEUS")])]), _vm._v(" "), _vm._l((_vm.monthContainerExportList), function(rev_item, rev_index) {
    return _c('tr', {
      key: rev_index
    }, [_c('td', [_vm._v(_vm._s(parseInt(rev_index + 1)) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(rev_item.fromDate + " to " + rev_item.toDate))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(rev_item.TotSeaExportExe) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(rev_item.TotFFSeaExportExeCont) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(rev_item.totalExecutionContExpTUES) + "\n                  ")])])
  }), _vm._v(" "), (_vm.monthContainerExportList.length <= 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "color": "purple"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('b', [_vm._v("Data Not Found")])])]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), (
    _vm.monthContainerExportList.length > 0 &&
    _vm.Filter.transportTypeFilter == 'Import'
  ) ? _c('div', {
    staticClass: "col-md-12 mt-2 mb-2 card"
  }, [_c('table', {
    staticClass: "table table-bordered table-sm card-body"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("SN")]), _vm._v(" "), _c('th', [_vm._v("Month")]), _vm._v(" "), _c('th', [_vm._v("Import Tot Exe")]), _vm._v(" "), _c('th', [_vm._v("Import Tot Containers")]), _vm._v(" "), _c('th', [_vm._v("Import Tot TEUS")])]), _vm._v(" "), _vm._l((_vm.monthContainerExportList), function(rev_item, rev_index) {
    return _c('tr', {
      key: rev_index
    }, [_c('td', [_vm._v(_vm._s(parseInt(rev_index + 1)) + ".")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(rev_item.fromDate + " to " + rev_item.toDate))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(rev_item.TotSeaImportExe) + "\n                  ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(rev_item.TotFFSeaImportExeCont))]), _vm._v(" "), _c('td', [_vm._v("\n                    " + _vm._s(rev_item.totalExecutionContImpTUES) + "\n                  ")])])
  }), _vm._v(" "), (_vm.monthContainerExportList.length <= 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "text-align": "center",
      "color": "purple"
    },
    attrs: {
      "colspan": "4"
    }
  }, [_c('b', [_vm._v("Data Not Found")])])]) : _vm._e()], 2)])]) : _vm._e(), _vm._v(" "), _c('BranchWiseTeusTable', {
    attrs: {
      "dateRange": _vm.dateRange,
      "filter": _vm.Filter
    }
  }), _vm._v(" "), _c('ClientWiseTeusTable', {
    attrs: {
      "dateRange": _vm.dateRange,
      "filter": _vm.Filter
    }
  }), _vm._v(" "), _c('ShippingLineWiseTeusTable', {
    attrs: {
      "dateRange": _vm.dateRange,
      "filter": _vm.Filter
    }
  }), _vm._v(" "), _c('ContainerTypeWiseTeusTable', {
    attrs: {
      "dateRange": _vm.dateRange,
      "filter": _vm.Filter
    }
  }), _vm._v(" "), _c('b-row', [(_vm.$store.getters.appDeviceType != 'Phone') ? _c('b-col', {
    staticClass: "mt-5",
    attrs: {
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "card card-statistics formCardDash"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between flex-wrap"
  }, [_c('div', [_c('h6', {
    staticClass: "card-title"
  }, [_vm._v("TOTAL Volume Chart")]), _vm._v(" "), _c('div', {
    staticClass: "fluid-container"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "chart1"
    }
  }, [(_vm.series.length > 0) ? _c('apexchart', {
    staticClass: "mt-3",
    attrs: {
      "type": "pie",
      "height": "600",
      "width": "1200",
      "options": _vm.chartOptions,
      "series": _vm.series
    }
  }) : _vm._e()], 1)])])])])]) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row gutr"
  })], 1) : _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-navbar', {
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "info"
    }
  }, [(_vm.showDash == false) ? _c('b-navbar-brand', [(_vm.employeeName != '') ? _c('h4', {
    staticClass: "page-title"
  }, [_vm._v("\n            Welcome\n            "), _c('small', [_vm._v(_vm._s(_vm.employeeName))])]) : _vm._e()]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop22",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7404fae4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/tuesVolumeCard.vue
// module id = 2748
// module chunks = 0